import { createApp } from 'vue';
import App from './Cart.vue';
import {useTippy} from '../../../_helpers/vue-tippy';

document.querySelectorAll('[data-cart]').forEach((el) => {
    const app = createApp(App);
    app.config.globalProperties.$config = JSON.parse(el.dataset.cart);

    useTippy(app);

    app.mount(el);
});
